
$('.image-banner-slider').owlCarousel({
  loop: true,
  autoplay: true,
  autoplayTimeout: 3000,
  smartSpeed: 300,
  autoplaySpeed: 300,
  autoplayHoverPause: true,
  slideTransition: 'ease-in-out',
  margin: 0,
  nav: true,
  dots: true,
  autoWidth: true,
  center: true,
  startPosition: 0,
  navText: [
    '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="18px" height="30px" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path style="opacity:0.898" fill="#006836" d="M 12.5,-0.5 C 13.8333,-0.5 15.1667,-0.5 16.5,-0.5C 16.5,0.166667 16.8333,0.5 17.5,0.5C 17.5,9.83333 17.5,19.1667 17.5,28.5C 16.8333,28.5 16.5,28.8333 16.5,29.5C 15.1667,29.5 13.8333,29.5 12.5,29.5C 8.13858,24.8073 3.80525,20.1406 -0.5,15.5C -0.5,14.8333 -0.5,14.1667 -0.5,13.5C 3.80525,8.85942 8.13858,4.19275 12.5,-0.5 Z"/></g></svg>',
    '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="17px" height="30px" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path style="opacity:0.969" fill="#006937" d="M -0.5,-0.5 C 1.16667,-0.5 2.83333,-0.5 4.5,-0.5C 8.52817,3.85934 12.5282,8.19268 16.5,12.5C 16.5,13.8333 16.5,15.1667 16.5,16.5C 12.5282,20.8073 8.52817,25.1407 4.5,29.5C 2.83333,29.5 1.16667,29.5 -0.5,29.5C -0.5,19.5 -0.5,9.5 -0.5,-0.5 Z"/></g></svg>',
  ],
  responsive: {
    0: {
      items: 1,
      autoWidth: false,
      nav: false,
    },
    768: {
      items: 1,
      autoWidth: true,
    },
  },
});


$('.announcement-cstm-slider').owlCarousel({
  loop: true,
  autoplay: true,
  autoplayTimeout: 3000,
  smartSpeed: 300,
  autoplaySpeed: 300,
  autoplayHoverPause: true,
  slideTransition: 'ease-in-out',
  margin: 0,
  nav: true,
  dots: false,
  items: 1,          // Show 1 item per slide
  center: false,     // Do NOT center – let it stretch to full width
  autoWidth: false,  // VERY IMPORTANT: disables dynamic width
  navText: [
    '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="18px" height="30px" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path style="opacity:0.898" fill="#006836" d="M 12.5,-0.5 C 13.8333,-0.5 15.1667,-0.5 16.5,-0.5C 16.5,0.166667 16.8333,0.5 17.5,0.5C 17.5,9.83333 17.5,19.1667 17.5,28.5C 16.8333,28.5 16.5,28.8333 16.5,29.5C 15.1667,29.5 13.8333,29.5 12.5,29.5C 8.13858,24.8073 3.80525,20.1406 -0.5,15.5C -0.5,14.8333 -0.5,14.1667 -0.5,13.5C 3.80525,8.85942 8.13858,4.19275 12.5,-0.5 Z"/></g></svg>',
    '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="17px" height="30px" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path style="opacity:0.969" fill="#006937" d="M -0.5,-0.5 C 1.16667,-0.5 2.83333,-0.5 4.5,-0.5C 8.52817,3.85934 12.5282,8.19268 16.5,12.5C 16.5,13.8333 16.5,15.1667 16.5,16.5C 12.5282,20.8073 8.52817,25.1407 4.5,29.5C 2.83333,29.5 1.16667,29.5 -0.5,29.5C -0.5,19.5 -0.5,9.5 -0.5,-0.5 Z"/></g></svg>',
  ],
});

